let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gpgZU")).then(() => parcelRequire('kel6P'));